import { PeerEventsType } from "@domain";
import { RoomStreamingBloc } from "modules/room/RoomStreamingBloc";
import { SignalingService } from "modules/room/services";

export abstract class BasePeerCommand {
  constructor(
    protected readonly bloc: RoomStreamingBloc,
    protected readonly signalingService: SignalingService
  ) {}

  protected getRoom() {
    const room = this.bloc.state.room;
    if (room === null) throw new Error("Room is null");
    return room;
  }

  protected getRoomLocalParticipantDisplayName() {
    const room = this.getRoom();
    const localParticipant = room.localParticipant;
    if (!localParticipant) throw new Error("Local participant not found");
    return localParticipant.displayName;
  }

  protected getRoomLocalParticipantRemoteId(): number {
    const room = this.getRoom();
    const localParticipant = room.localParticipant;
    if (!localParticipant) throw new Error("Local participant not found");
    if (!localParticipant.remoteId) throw new Error("Remote id not found");
    return localParticipant.remoteId.toValue() as number;
  }

  public abstract execute(e: CustomEvent<PeerEventsType>): void;
}
